<template>
  <div>
    <el-row type="flex" justify="space-between">
      <div class="top-info">
        <el-button class="fontsize18" icon="el-icon-arrow-left" size="mini" @click="$router.go(-1)">
          返回
        </el-button>
        <div class="mr-10 fontsize18">姓名：{{ params.name }}</div>
        <div class="fontsize18">岗位：{{ params.postName }}</div>
      </div>
      <div class="datePicker">
        <el-date-picker
          v-model="date"
          type="daterange"
          placeholder="选择日期"
          class="datePicker"
          value-format="yyyy-MM-dd"
          @change="getData"
        >
        </el-date-picker>
      </div>
    </el-row>
    <div class="mt-10">
      <el-table
        header-cell-class-name="table-header"
        cell-class-name="row-cell"
        :data="tableList"
        class="table mt20 table-container"
      >
        <el-table-column
          label="序号"
          type="index"
          width="100"
        ></el-table-column>
        <el-table-column
          label="开具时间"
          prop="createTime"
          width="200"
        ></el-table-column>
        <el-table-column label="整改标题" prop="content">
          <template slot-scope="scope">
            <div
              style="
                max-width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: left;
              "
            >
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="整改状态" prop="status" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="color1">已下发</span>
            <span v-if="scope.row.status == 1" class="color1">整改中</span>
            <span v-if="scope.row.status == 2" class="color1">待验收</span>
            <span v-if="scope.row.status == 3" class="color2">已完成</span>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" prop="realEndTime" width="200">
        </el-table-column>
        <el-table-column label="是否逾期" prop="delayFlag" width="150">
          <template slot-scope="scope">
            <span :class="scope.row.delayFlag == '是' ? 'color1' : 'color2'">{{
              scope.row.delayFlag
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="详情" prop="name" width="150">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              @click="handleDetail(scope.row)"
              >点击查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="block mt10 pagetion">
        <el-pagination
          layout="total, prev, pager, next"
          :total="pageData.total"
          :page-size="pageData.pageSize"
          :current-page.sync="pageData.pageNum"
          @current-change="getData"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="要求与整改单详情"
      :visible.sync="showReformDetail"
      width="600px"
      :modal-append-to-body="false"
    >
      <div style="max-height: 60vh; overflow-y: scroll">
        <reform-detail
          :dataInfo="reformDetailData"
          :reFormRecord="reFormRecord"
        ></reform-detail>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="showRegulationList = false">取 消</el-button> -->
        <el-button
          type="primary"
          @click="
            showReformDetail = false;
            reformDetailData = [];
          "
          >返 回</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment"
// import ReformDetail from "../onstructionData/workManage/reformDetail.vue";
// import TopHeader from "./components/top-header.vue";
import { getReformList, getReformDetail, getReformRecord } from "./api.js";
// import Template from "../../components/calendarUi/template.vue";
export default {
  components: {
    // TopHeader,
    // Template,
    // ReformDetail,
  },
  data() {
    return {
      showReformDetail: false,
      params: {},
      date: [],
      pageData: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableList: [],
      reformDetailData: {},
      reFormRecord: [],
    };
  },
  mounted() {
    this.params = this.$route.query;
    var dates = sessionStorage.getItem('dates')
    dates = moment(dates).format("yyyy-MM-DD")
    this.date = [dates, dates];
    // this.date = [this.params.date, this.params.date];
    this.calcHeight();
    //  window.addEventListener('resize', this.handleResize);
  },
  methods: {
    getData() {
      getReformList({
        projectUserInfoHistoryId: this.params.projectUserInfoHistoryId,
        beginningTime: this.date[0],
        endingTime: this.date[1],
        ...this.pageData,
      }).then((res) => {
        this.tableList = res.data.rows;
        this.pageData.total = res.data.total;
      });
    },
    //要求与整改单详情
    openReformDetail(row) {
      getReformDetail({
        reformId: row.reformId,
        type: 3,
      }).then((res) => {
        if (res.code === 200) {
          this.reformDetailData = res.data;
          this.showReformDetail = true;
        }
      });
    },
    handleDetail(row) {
      getReformDetail({
        reformId: row.reformId,
        projectUserInfoHistoryId: row.projectUserInfoHistoryId,
      }).then((res) => {
        this.reformDetailData = res.data;
        this.showReformDetail = true;
      });
      getReformRecord({
        reformId: row.reformId,
      }).then((res) => {
        if (res.code === 200) {
          this.reFormRecord = res.data.rows;
        }
      });
    },
    calcHeight() {
      if (this.pageData.pageNum > 1) {
        return;
      }
      const myElement = document.getElementsByClassName("top-info")[0];
      const rect = myElement.getBoundingClientRect();
      const distanceToBottom = window.innerHeight - rect.bottom - 200;
      this.pageData.pageSize = Math.floor(distanceToBottom / 60);
      this.getData();
    },
    handleResize() {
      this.calcHeight();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="less" scoped>
.top-info {
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
}
.datePicker ::v-deep .el-input__inner,
.datePicker ::v-deep .el-input__inner .el-range-separator {
  background: rgba(0, 0, 0, 0);
  color: #fff;
}
::v-deep .el-table {
  background: rgba(0, 0, 0, 0);
}
::v-deep .el-table tr {
  background: rgba(0, 0, 0, 0);
}
.datePicker{
  display: flex;
  justify-content: center;
}
.datePicker ::v-deep .el-range-input {
  background: rgba(0, 0, 0, 0);
  color: #fff;
}
::v-deep .el-table {
  background: rgba(0, 0, 0, 0);
}
::v-deep .el-table tr {
  background: rgba(0, 0, 0, 0);
}

.color1 {
  color: #ff0000;
}
.color2 {
  color: #0ac200;
}
.mt-10{
  margin-top: 0.1rem;
}
.fontsize18{
  // font-size: 0.18rem;
}
</style>
